import { 
  isAgencyTypeApplication, 
  isReadyForPayment, 
  isRenewalTypeApplication, 
  isCollectionTypeApplication, 
  applicationTypeFromLicenceSubType 
} from "../redux/slice/applicationsUtils"
import { 
  APPLICATION_MODE_NEW, 
  APPLICATION_MODE_RENEW, 
  APPLICATION_TYPE_COLLECTION_AGENCY, 
  APPLICATION_TYPE_DEBT_MANAGEMENT_AGENCY,
  APPLICATION_TYPE_COLLECTOR, 
  CanadaProvinceList,
  APPLICATION_TYPE_DEBT_MANAGEMENT_AGENT,
  // PAYMENT_STATUS_SUCCESS,
  LICENCE_SUB_TYPE_COLLECTION_AGENCY_APPLICATION,
  LICENCE_SUB_TYPE_COLLECTION_AGENCY_RENEWAL,
  LICENCE_SUB_TYPE_COLLECTION_COLLECTOR_APPLICATION,
  LICENCE_SUB_TYPE_COLLECTION_COLLECTOR_RENEWAL,
  LICENCE_SUB_TYPE_DEBT_MANAGEMENT_APPLICATION,
  LICENCE_SUB_TYPE_DEBT_MANAGEMENT_RENEWAL,
  LICENCE_SUB_TYPE_DEBT_MANAGEMENT_INDIVIDUAL_APPLICATION,
  LICENCE_SUB_TYPE_DEBT_MANAGEMENT_INDIVIDUAL_RENEWAL,
  APPLICATION_STATUS_PENDING_PAYMENT,
  AUTHORITY_BUSINESS_LICENCE_ADMIN,
  LICENCE_SUB_TYPE_MORTGAGE_BROKERAGE_NEW_APPLICATION,
  LICENCE_SUB_TYPE_PRINCIPAL_BROKER_NEW_APPLICATION,
  LICENCE_SUB_TYPE_MORTGAGE_BROKER_NEW_APPLICATION,
  LICENCE_SUB_TYPE_ASSOCIATE_MORTGAGE_BROKER_NEW_APPLICATION,
  LICENCE_SUB_TYPE_MORTGAGE_LENDER_NEW_APPLICATION,
  LICENCE_SUB_TYPE_MORTGAGE_ADMINISTRATOR_NEW_APPLICATION,
  LICENCE_SUB_TYPE_ALL,
  LICENCE_SUB_TYPE_MORTGAGE_BROKER_RENEWAL_APPLICATION,
  LICENCE_SUB_TYPE_PRINCIPAL_BROKER_RENEWAL_APPLICATION,
  LICENCE_SUB_TYPE_ASSOCIATE_MORTGAGE_BROKER_RENEWAL_APPLICATION,
  LICENCE_SUB_TYPE_MORTGAGE_LENDER_RENEWAL_APPLICATION,
  LICENCE_SUB_TYPE_MORTGAGE_ADMINISTRATOR_RENEWAL_APPLICATION,
  LICENCE_SUB_TYPE_MORTGAGE_BROKERAGE_RENEWAL_APPLICATION,
  DOCUMENT_TYPE_INSURANCE_CONTINURATION,
  DOCUMENT_TYPE_INSURANCE_PROOF,
  LICENCE_SUB_TYPE_INDIVIDUAL_PRINCIPAL_BROKER_APPLICATION,
  LICENCE_SUB_TYPE_INDIVIDUAL_COMPLIANCE_OFFICER_APPLICATION,
  LICENCE_SUB_TYPE_INDIVIDUAL_PRINCIPAL_BROKER_RETENTION_APPLICATION,
  LICENCE_SUB_TYPE_INDIVIDUAL_COMPLIANCE_OFFICER_RETENTION_APPLICATION,
} from "./constants"
import { 
  LICENCE_SUB_TYPE_MORTGAGE_ADMINISTRATOR_CHANGE_APPLICATION,
  LICENCE_SUB_TYPE_MORTGAGE_BROKERAGE_CHANGE_APPLICATION,
  LICENCE_SUB_TYPE_MORTGAGE_LENDER_CHANGE_APPLICATION
} from "./constants/licence_sub_type_constants"
import { VALIDATION_ERROR, VALIDATION_TYPE } from "./errors"
import { SUPER_USERS } from "./SuperUsers"

export const dummyRjscSearchResponse = () => {
    return [
      {
        businessName : "Dummy Company Name 1",
        registryNumber : "123456",
        entityId : 123456
      }, 
      {
        businessName : "Dummy Company Name 2",
        registryNumber : "123457",
        entityId : 123457
      }
    ]
}

export function dummyApplicationData(){

  if(0) {
    return {}
  }

  return {
    companyRjscDetails: {
        businessEntity: {
          businessName: 'Dummy Company Name 1',
          registryNumber: '123456'
        },
        status: 'ACTIVE',
        businessContact: {
          civicAddress: {
            formattedOutput: '123 ABC Streets, NS, CA'
          },
          mailingAddress: {
            formattedOutput: '123 ABC Streets, NS, CA'
          }
        }
      },
      businessName: 'Dummy Company Name 1',
      registryNumber: '123456',
      mainBusinessContact: {
        firstName: 'James',
        lastName: 'Bond',
        phoneNumber: '9029020007',
        emailAddress: 'james.bond.007@gmail.com'
      },
      complianceOfficer: {
        firstName: 'James',
        lastName: 'Bond',
        phoneNumber: '9029020007',
        emailAddress: 'james.bond.007@gmail.com'
      },
      serviceCivicAddress: {
        singleLineAddress: '111 Main St, Halifax, NS'
      },
      financialRecordsLocation: {
        singleLineAddress: '222 Financial St, Halifax, NS'
      },
      licenceHistoryList: [
        {
          businessLicenceType: 'Collection',
          province: 'British Columbia',
          startDate: 1286679600000,
          endDate: 1539140400000
        }
      ],
      licenceSuspendedData: [
        {
          businessLicenceType: 'Collection',
          province: 'British Columbia',
          suspensionDate: 1493524800000,
          reason: 'Forgot to renew'
        }
      ],
      additionalBranches: [
        {
          branchName: 'Branch 1',
          address : {
            singleLineAddress : '111 Hope Street, NS'
          }, 
          manager : {
            firstName: 'Jack Danials',
            phoneNumber: '9027776666',
            emailAddress: 'jacob.mark@gmail.com'
          }
        }
      ],
      formsAgreements: [
        {
          filename: 'Sample_Agreement.pdf',
          changeType: "SAVE",
          documentContentType: 'PDF',
          businessLicencingSubType : "COLLECTION_AGENCY_APPLICATION",
          documentType : "FORMS_AGREEMENT",
          data: 'UmVsZWFzZS1BZ2VudC1CdWlsZC02NC0yXzE4XzEgDQoyLjE4LjEuNCANCjU4OTE0ODU3NmZmMzZhYjNmZThiN2JjM2FjOTdhMmNiZDFmNWRlZmEgDQo='
        }
      ],
      noticesLetters: [
        {
          filename: 'Sample_Notice_Letter.pdf',
          changeType: "SAVE",
          documentContentType: 'PDF',
          businessLicencingSubType : "COLLECTION_AGENCY_APPLICATION",
          documentType : "NOTICES_LETTERS",
          data: 'UmVsZWFzZS1BZ2VudC1CdWlsZC02NC0yXzE4XzEgDQoyLjE4LjEuNCANCjU4OTE0ODU3NmZmMzZhYjNmZThiN2JjM2FjOTdhMmNiZDFmNWRlZmEgDQo='
        }
      ],
      trustAccountInstitution: {
        name: 'Scotia bank',
        branchName: 'Scotia Square',
        address: {
          singleLineAddress: '5201 Duke St, Halifax, NS'
        }
      },
      trustAccountFinancialStatementLetter : {
        filename: 'Sample_Bank_Letter.pdf',
        changeType: "SAVE",
        documentContentType: 'PDF',
        businessLicencingSubType : "COLLECTION_AGENCY_APPLICATION",
          documentType : "FINANCIAL_STATEMENT_LETTER",
        data: 'UmVsZWFzZS1BZ2VudC1CdWlsZC02NC0yXzE4XzEgDQoyLjE4LjEuNCANCjU4OTE0ODU3NmZmMzZhYjNmZThiN2JjM2FjOTdhMmNiZDFmNWRlZmEgDQo='
      },
      confirmSuretyBond: true,
      saveApplicationDataStatus: 'success'
    }
}

export function dummyCollectorApplicationData() { 
  return {
    collectors: [
      {
        applicantDetails: {
          firstName: 'Maggie',
          lastName: 'Smith',
          phoneNumber: '9024122453',
          emailAddress: 'maggie.smith@gmail.com',
          civicAddress: '111 Main St, Halifax, NS'
        }
      },
      {
        applicantDetails: {
          firstName: 'John',
          lastName: 'Smith',
          phoneNumber: '9024122453',
          emailAddress: 'john.smith@gmail.com',
          civicAddress: '112 Main St, Halifax, NS'
        }
      }
    ],
    currentCollectorIndex: 0
  }
}

export function dummyInitialStateCollectionApplicationData() {
  if(0) {
    return {}
  }

  return {
      businessName: 'The Barrington Consulting Group Incorporated',
      companyRjscDetails: {
        businessEntity: {
          entityId: '3268880',
          businessName: 'The Barrington Consulting Group Incorporated',
          registryNumber: '3268880'
        },
        businessContact: {
          phoneNumber: null,
          fax: null,
          email: null,
          civicAddress: {
            city: 'Halifax',
            postalCode: 'b3j 1z1',
            province: 'Nova Scotia',
            street: '1326 Barrington Street',
            formattedOutput: '1326 BARRINGTON STREET,HALIFAX, NOVA SCOTIA,B3J 1Z1'
          },
          mailingAddress: {
            city: 'Halifax',
            postalCode: 'b3j 1z1',
            province: 'Nova Scotia',
            street: '1326 Barrington St',
            formattedOutput: '1326 BARRINGTON ST,HALIFAX, NOVA SCOTIA,B3J 1Z1'
          }
        },
        businessData: {
          expiryDate: 1641009599000,
          companyTypeId: null,
          companyType: 'Limited Company',
          phoneNumber: null,
          peopleList: [
            {
              entityId: '4284420',
              firstName: 'Andrew',
              lastName: 'Creaser',
              position: 'Director',
              status: 'Active',
              civicAddress: {
                city: 'Halifax',
                postalCode: 'b3j 1z1',
                province: 'Nova Scotia',
                street: '1326 Barrington Street',
                formattedOutput: '1326 BARRINGTON STREET,HALIFAX, NOVA SCOTIA,B3J 1Z1'
              },
              mailingAddress: null
            },
            {
              entityId: '4284421',
              firstName: 'Andrew',
              lastName: 'Creaser',
              position: 'Officer',
              status: 'Active',
              civicAddress: {
                city: 'Halifax',
                postalCode: 'b3j 1z1',
                province: 'Nova Scotia',
                street: '1326 Barrington Street',
                formattedOutput: '1326 BARRINGTON STREET,HALIFAX, NOVA SCOTIA,B3J 1Z1'
              },
              mailingAddress: null
            },
            {
              entityId: '3529414',
              firstName: 'Tammy E',
              lastName: 'Richards',
              position: 'Recognized Agent',
              status: 'Active',
              civicAddress: {
                city: 'Halifax',
                postalCode: 'b3j 1z1',
                province: 'Nova Scotia',
                street: '1326 Barrington Street',
                formattedOutput: '1326 BARRINGTON STREET,HALIFAX, NOVA SCOTIA,B3J 1Z1'
              },
              mailingAddress: null
            },
            {
              entityId: '4284422',
              firstName: 'David',
              lastName: 'Berrigan',
              position: 'Officer',
              status: 'Active',
              civicAddress: {
                city: 'Halifax',
                postalCode: 'b3j 1z1',
                province: 'Nova Scotia',
                street: '1326 Barrington Street',
                formattedOutput: '1326 BARRINGTON STREET,HALIFAX, NOVA SCOTIA,B3J 1Z1'
              },
              mailingAddress: null
            },
            {
              entityId: '4284423',
              firstName: 'Joel',
              lastName: 'Aguinaga',
              position: 'Officer',
              status: 'Active',
              civicAddress: {
                city: 'Halifax',
                postalCode: 'b3j 1z1',
                province: 'Nova Scotia',
                street: '1326 Barrington Street',
                formattedOutput: '1326 BARRINGTON STREET,HALIFAX, NOVA SCOTIA,B3J 1Z1'
              },
              mailingAddress: null
            }
          ]
        },
        authorized: false,
        status: 'ACTIVE',
        order: 0
      },
      complianceOfficer: {
        firstName: 'John',
        lastName: 'Smith',
        phoneNumber: '9027896610',
        emailAddress: 'john.smith@gmail.com'
      },
      mainBusinessContact: {
        firstName: 'John',
        lastName: 'Smith',
        phoneNumber: '9027896610',
        emailAddress: 'john.smith@gmail.com'
      },
      registryNumber: '3268880',
      serviceCivicAddress: {
        singleLineAddress: '111 Main St, Halifax'
      },
      financialRecordsLocation: {
        singleLineAddress: '222 Main St, Halifax'
      },
      licenceHistoryList: [],
      licenceSuspendedData: [{
        businessLicenceType : "Collection Agency",
        province : "Nova Scotia",
        suspensionDate : 1556596800000,
        reason : "Forgot to renew"
      }],
      additionalBranches: [
        {
          branchName: 'Branch 2',
          address: {
            singleLineAddress: '333 Main St, Halifax'
          },
          manager: {
            firstName: 'Jack ',
            phoneNumber: 'Smith',
            emailAddress: 'jack.smith@gmail.com'
          }
        }
      ],
      formsAgreements: [],
      noticesLetters: [],
      trustAccountInstitution: {
        name: 'Scotia bank',
        branchName: 'scotia square',
        address: {
          singleLineAddress: '5201 Duke St, Halifax'
        }
      },
      trustAccountFinancialStatementLetter: {},
      confirmSuretyBond: true
  }
}

export function dummyInitialStateCollectorApplicationData() { 
  if(1) {
    return {}
  }

  return {
    collectors: [
      {
        applicantDetails: {
          firstName: 'Maggie',
          lastName: 'Smith',
          phoneNumber: '9024122453',
          emailAddress: 'maggie.smith@gmail.com',
          civicAddress: '111 Main St, Halifax, NS'
        }
      },
      {
        applicantDetails: {
          firstName: 'John',
          lastName: 'Smith',
          phoneNumber: '9024122453',
          emailAddress: 'john.smith@gmail.com',
          civicAddress: '112 Main St, Halifax, NS'
        }
      }
    ],
    currentCollectorIndex: 0
  }
}

export function replaceUrlParams (url, applicationType, applicationMode) { 
  let nextUrl = url.replace(':applicationMode', applicationMode)
  return  nextUrl.replace(':applicationType', applicationType)
}

export function mainTitleMapping(applicationType, applicationMode) { 
  let titleComponents = []

  if(applicationMode === APPLICATION_MODE_NEW) { 
    titleComponents.push("Apply")
  } else if(applicationMode === APPLICATION_MODE_RENEW) { 
    titleComponents.push("Renew")
  }

  if(applicationType === APPLICATION_TYPE_COLLECTION_AGENCY) { 
    titleComponents.push("Collection Agency Licence")
  } else if(applicationType === APPLICATION_TYPE_DEBT_MANAGEMENT_AGENCY) {
    titleComponents.push("Debt Management Agency Licence")
  } else if(applicationType === APPLICATION_TYPE_COLLECTOR) {
    titleComponents.push("Collector Licence")
  } else if(applicationType === APPLICATION_TYPE_DEBT_MANAGEMENT_AGENT) {
    titleComponents.push("Debt Management Agent Licence")
  }

  return titleComponents.join(" ")
}

export function GetProviceCodeFromName(provinceName) {
  if(!provinceName)
    return ""
    
  let province = provinceName.toLowerCase()

  for (const key in   CanadaProvinceList) {
    if (Object.hasOwnProperty.call(  CanadaProvinceList, key)) {
      const p =   CanadaProvinceList[key].toLowerCase();
      if(p === province) {
        return key
      }
    }
  }

  return provinceName
}

/*
 * A JavaScript date is fundamentally specified as the number of milliseconds 
 * that have elapsed since midnight on January 1, 1970, UTC.
 */
export function humanReadableDate(miliseconds, hideYear = false) { 
  if(!miliseconds) { 
    return ""
  }

  let dateObj = new Date(parseInt(miliseconds))

  let option = {
    year: "numeric",
    month: "long",
    day : "numeric"
  }

  if(hideYear) {
    option = {
      month: "long",
      day : "numeric"
    }
  }

  return dateObj.toLocaleDateString("en-US",option)
}

export function humanReadableDateTime(miliseconds) { 
  if(!miliseconds) { 
    return ""
  }

  let dateObj = new Date(parseInt(miliseconds))

  const option = {
    year: "numeric",
    month: "long",
    day : "numeric",
    hour: "numeric",
    minute: "numeric"
  }

  return dateObj.toLocaleDateString("en-US",option)
}

export function replaceCollectorName(string, agentName) {
  let replaceRegExp = /<collector_name>/g
  return string.replace(replaceRegExp,`<strong>${agentName}</strong>`)
}

export function validateBranchData(branchData) {

  if(!branchData.branchName)
      return false
  
  return true
}

export function validateAgentData(agentApplication) { 
  
  if(!agentApplication) {
    return false
  }

  if(!agentApplication?.businessApplicationId) {
    return false
  } else if(agentApplication?.changeType === "DELETE") {
    return false
  } else if(!isRenewalTypeApplication(agentApplication) && 
              !agentApplication.businessLicenceData?.userApplicationReviewComplete) {
    console.log("application not reviewed yet",agentApplication.id)
    return false
  }

  return true
}

export function validateBrokerData(brokerApplication) {
  return validateAgentData(brokerApplication)
}

export function computeMARenewalCost(
  primaryApplication,
  administratorRenewalFees) 
{
  let administratorRenewalCost = 0
  administratorRenewalFees = +administratorRenewalFees

  if(primaryApplication && isReadyForPayment(primaryApplication)) { 
    administratorRenewalCost = administratorRenewalFees
  }

  return {
    administratorRenewalCost
  }
}
export function computeMLRenewalCost(
                          primaryApplication,
                          lenderRenewalFees
                        ) 
{ 
  let lenderRenewalCost = 0

  lenderRenewalFees = +lenderRenewalFees

  if(primaryApplication && isReadyForPayment(primaryApplication)) { 
    lenderRenewalCost = lenderRenewalFees
  }

  return {
    lenderRenewalCost
  }
}

export function computeMLCost(
                          primaryApplication,
                          lenderFees
                        ) 
{ 
  let lenderCost = 0

  lenderFees = +lenderFees

  if(primaryApplication && isReadyForPayment(primaryApplication)) { 
    lenderCost = lenderFees
  }

  return {
    lenderCost
  }
}

export function computeMraRenewalCost (
  primaryApplication, 
  brokerApplications,
  brokerageRenewalFees,
  brokerRenewalFees, 
  associateBrokerRenewalFees,
  principalBrokerRenewalFees, 
  paymentRequestedForIds) 
{
  let brokerageCost = 0, brokerCost = 0, associateBrokerCost = 0, principalBrokerCost = 0
  let brokerQuantity = 0, associateBrokerQuantity = 0, principalBrokerQuantity = 0

  // converting to number
  brokerageRenewalFees = +brokerageRenewalFees
  brokerRenewalFees = +brokerRenewalFees
  associateBrokerRenewalFees = +associateBrokerRenewalFees
  principalBrokerRenewalFees = +principalBrokerRenewalFees

  const isPaymentRequestedForId = (id) => {
    if(!paymentRequestedForIds || paymentRequestedForIds.length === 0) {
      return true
    }

    return (paymentRequestedForIds.findIndex(requestedId => requestedId === id) !== -1)
  }

  if(primaryApplication 
      && isPaymentRequestedForId(primaryApplication.id)
      && isReadyForPayment(primaryApplication)) { 
    brokerageCost = brokerageRenewalFees
  }

  if(brokerApplications 
    && Array.isArray(brokerApplications) 
    && brokerApplications.length) {
    brokerApplications.forEach((application) => {

      if(isReadyForPayment(application) 
        && isPaymentRequestedForId(application.id)
        && validateBrokerData(application))
      {
        if(application.licencingSubType === LICENCE_SUB_TYPE_PRINCIPAL_BROKER_RENEWAL_APPLICATION) { 
          principalBrokerCost += principalBrokerRenewalFees
          principalBrokerQuantity++
        } else if(application.licencingSubType === LICENCE_SUB_TYPE_ASSOCIATE_MORTGAGE_BROKER_RENEWAL_APPLICATION) {
          associateBrokerCost += associateBrokerRenewalFees
          associateBrokerQuantity++
        } else { 
        brokerCost += brokerRenewalFees
          brokerQuantity++
        }
      }
    })
  }

  return {
    brokerageCost,
    principalBrokerQuantity,
    principalBrokerCost,
    brokerQuantity,
    brokerCost,
    associateBrokerQuantity,
    associateBrokerCost
    }
}

export function isMainAgentRetentionApplication(application) { 
  if(application?.licencingSubType === LICENCE_SUB_TYPE_INDIVIDUAL_PRINCIPAL_BROKER_RETENTION_APPLICATION
    || application?.licencingSubType === LICENCE_SUB_TYPE_INDIVIDUAL_COMPLIANCE_OFFICER_RETENTION_APPLICATION) {
      return true;
  } else if (application?.licencingSubType === LICENCE_SUB_TYPE_INDIVIDUAL_PRINCIPAL_BROKER_APPLICATION
      || application?.licencingSubType === LICENCE_SUB_TYPE_INDIVIDUAL_COMPLIANCE_OFFICER_APPLICATION) {
    if(application?.businessLicenceData?.mraNSLicenceNumber?.length > 0) {
      return true;
    }
  }
  return false;
}

export function computeMortgageMainAgentCost(
                        primaryApplication, 
                        brokerageFees,
                        brokerageRetentionFees, 
                        paymentRequestedForIds) 
{ 
  let brokerageCost = 0, brokerageRetentionCost = 0

  // converting to number
  brokerageFees = +brokerageFees
  brokerageRetentionFees = +brokerageRetentionFees

  const isPaymentRequestedForId = (id) => {
    if(!paymentRequestedForIds || paymentRequestedForIds.length === 0) {
      return true
    }

    return (paymentRequestedForIds.findIndex(requestedId => requestedId === id) !== -1)
  }

  if(primaryApplication 
      && isPaymentRequestedForId(primaryApplication.id) 
      && isReadyForPayment(primaryApplication)) { 

      if(isMainAgentRetentionApplication(primaryApplication)) {
        brokerageRetentionCost = brokerageRetentionFees
      } else { 
        brokerageCost = brokerageFees
      }
  }

  return {
    brokerageCost,
    brokerageRetentionCost
  }
}

export function computeMraCost (
                        primaryApplication, 
                        brokerApplications,
                        agencyFeesStructure,
                        paymentRequestedForIds) 
{
  let brokerageCost = 0, brokerCost = 0, associateBrokerCost = 0, principalBrokerCost = 0
  let brokerQuantity = 0, associateBrokerQuantity = 0, principalBrokerQuantity = 0
  let associateBrokerTransferCost = 0, associateBrokerTransferQuantity = 0; 
  let brokerTransferCost = 0, brokerTransferQuantity = 0; 

  let {
    brokerFees,
    brokerageFees,
    principalBrokerFees,
    associateBrokerFees,
    associateBrokerTransferFees,
    brokerTransferFees
  } = agencyFeesStructure;

  // converting to number
  brokerageFees = +brokerageFees
  brokerFees = +brokerFees
  associateBrokerFees = +associateBrokerFees
  principalBrokerFees = +principalBrokerFees
  associateBrokerTransferFees = +associateBrokerTransferFees
  brokerTransferFees = +brokerTransferFees

  const isPaymentRequestedForId = (id) => {
    if(!paymentRequestedForIds || paymentRequestedForIds.length === 0) {
      return true
    }

    return (paymentRequestedForIds.findIndex(requestedId => requestedId === id) !== -1)
  }

  if(primaryApplication 
      && isPaymentRequestedForId(primaryApplication.id) 
      && isReadyForPayment(primaryApplication)) { 
      brokerageCost = brokerageFees
  }

  if(brokerApplications 
    && Array.isArray(brokerApplications) 
    && brokerApplications.length) {
      brokerApplications.forEach((application) => {

          if(isReadyForPayment(application) 
            && isPaymentRequestedForId(application.id)
            && validateBrokerData(application))
          {
            if(application.licencingSubType === LICENCE_SUB_TYPE_PRINCIPAL_BROKER_NEW_APPLICATION) { 
              principalBrokerCost += principalBrokerFees
              principalBrokerQuantity++
            }
            else if(application.licencingSubType === LICENCE_SUB_TYPE_ASSOCIATE_MORTGAGE_BROKER_NEW_APPLICATION && application.businessLicenceData.brokerLicenceNumber && application.businessLicenceData.currentlyBrokerInNS ) {
              associateBrokerTransferCost += associateBrokerTransferFees
              associateBrokerTransferQuantity++
            }
            else if(application.licencingSubType === LICENCE_SUB_TYPE_MORTGAGE_BROKER_NEW_APPLICATION && application.businessLicenceData.brokerLicenceNumber && application.businessLicenceData.currentlyBrokerInNS ) {
              brokerTransferCost += brokerTransferFees
              brokerTransferQuantity++
            }
            else if(application.licencingSubType === LICENCE_SUB_TYPE_ASSOCIATE_MORTGAGE_BROKER_RENEWAL_APPLICATION && application.businessLicenceData.brokerLicenceNumber && application.businessLicenceData.currentlyBrokerInNS ) {
              associateBrokerTransferCost += associateBrokerTransferFees
              associateBrokerTransferQuantity++
            }
            else if(application.licencingSubType === LICENCE_SUB_TYPE_MORTGAGE_BROKER_RENEWAL_APPLICATION && application.businessLicenceData.brokerLicenceNumber && application.businessLicenceData.currentlyBrokerInNS ) {
              brokerTransferCost += brokerTransferFees
              brokerTransferQuantity++
            }
            else if(application.licencingSubType === LICENCE_SUB_TYPE_ASSOCIATE_MORTGAGE_BROKER_NEW_APPLICATION) {
              associateBrokerCost += associateBrokerFees
              associateBrokerQuantity++
            }
           
            else { 
              brokerCost += brokerFees
              brokerQuantity++
            }
          }
        })
  }

  return {
    brokerageCost,
    principalBrokerQuantity,
    principalBrokerCost,
    brokerQuantity,
    brokerCost,
    associateBrokerQuantity,
    associateBrokerCost,
    associateBrokerTransferQuantity,
    associateBrokerTransferCost,
    brokerTransferQuantity,
    brokerTransferCost
  }
}

export function computeCost(
                        primaryApplication, 
                        additionalBranchApplications, 
                        agentApplications, 
                        agencyFees,
                        agencyRenewalFees, 
                        branchFees, 
                        branchRenewalFees,
                        agentFees, 
                        agentRenewalFees) 
{

  let agencyCost = 0, branchCost = 0, agentCost = 0, agentRenewalCost = 0, branchRenewalCost = 0
  let additionalBranchQuantity = 0, agentQuantity = 0, agentRenewalQuantity = 0, additionalBranchRenewalQuantity = 0
  

  // converting to number
  agencyFees = +agencyFees
  branchFees = +branchFees
  agentFees = +agentFees

  if(primaryApplication && (!primaryApplication.applicationStatus 
    || primaryApplication.applicationStatus === APPLICATION_STATUS_PENDING_PAYMENT)) { 

      if(isRenewalTypeApplication(primaryApplication)) {
          agencyCost = agencyRenewalFees
      } else {
        agencyCost = agencyFees
      }
  }

  if(additionalBranchApplications 
    && Array.isArray(additionalBranchApplications)) {
      additionalBranchApplications.forEach(branchApplication => {
        if(branchApplication.applicationStatus === APPLICATION_STATUS_PENDING_PAYMENT
          && !branchApplication.markedDeleted) {
          // as long as the status is in PAYMENT_PENDING, include the cost of 
          // that branch. There will be single branch in an application.

          if(isRenewalTypeApplication(branchApplication)) {
            branchRenewalCost += branchRenewalFees
            additionalBranchRenewalQuantity++
          } else {
            branchCost += branchFees
            additionalBranchQuantity++
          }
          
          // if(branchApplication.businessLicenceData?.additionalBranches 
          //   && Array.isArray(branchApplication.businessLicenceData.additionalBranches) 
          //   && branchApplication.businessLicenceData.additionalBranches.length > 0) {
          //   branchApplication.businessLicenceData.additionalBranches.forEach((branch) => {
          //     if(validateBranchData(branch)) {
          //         branchCost += branchFees
          //         additionalBranchQuantity++
          //     }
          //   })
          // }
      }
    })
  }

  if(agentApplications 
    && Array.isArray(agentApplications) 
    && agentApplications.length) {
      agentApplications.forEach((agentApplication) => {
          if((!agentApplication.applicationStatus 
              || agentApplication.applicationStatus === APPLICATION_STATUS_PENDING_PAYMENT) 
              && validateAgentData(agentApplication))
          {
            if(isRenewalTypeApplication(agentApplication)) {
                agentRenewalCost += agentRenewalFees
                agentRenewalQuantity++
            }
            else {
              agentCost += agentFees
              agentQuantity++
            }
          }
        })
  }

  return {
    agencyCost,
    additionalBranchQuantity,
    branchCost,
    additionalBranchRenewalQuantity,
    branchRenewalCost,
    agentQuantity,
    agentCost,
    agentRenewalQuantity,
    agentRenewalCost
  }
}

export function financialNumber(num) {
  return Number.parseFloat(num).toFixed(2)
}

export function areContactObjectSame(contact1, contact2) { 

  if(Object.keys(contact1).length !== Object.keys(contact2).length)
    return false

  for (const key in contact1) {
    if (Object.hasOwnProperty.call(contact1, key)) {
      const element1 = contact1[key];
      if(Object.hasOwnProperty.call(contact2, key)) {
        const element2 = contact2[key];
        if(element1.toLowerCase() !== element2.toLowerCase()) {
          return false
        }
      } else { 
        return false
      }
    }
  } 
  
  return true
}

export function fullName(obj, defaultName = "") { 

  if(!obj)
      return defaultName
  
  let name = []

  if(obj.firstName) { 
    name.push(obj.firstName)
  } else if(obj.firstname) {
    name.push(obj.firstname)
  }

  if(obj.lastName) {
    name.push(obj.lastName)
  } else if(obj.lastname) {
    name.push(obj.lastname)
  }

  return name.length ? name.join(" ") : defaultName
}

export function combineAddress(addressObj, separator = ", ") {

  if(!addressObj) 
      return ""

  const addressComponents = [] 
  
  if(addressObj.singleLineAddress) {
    addressComponents.push(addressObj.singleLineAddress)
  } else {
    if(addressObj.street)
    addressComponents.push(addressObj.street)

    if(addressObj.address1)
      addressComponents.push(addressObj.address1)
  }
  

  if(addressObj.city)
      addressComponents.push(addressObj.city)
  else if(addressObj.cityName)
      addressComponents.push(addressObj.cityName)
  
  if(addressObj.province)
      addressComponents.push(addressObj.province)  
  else if(addressObj.stateName)
      addressComponents.push(addressObj.stateName)
  
  if(addressObj.postalCode)
      addressComponents.push(addressObj.postalCode)

  return addressComponents.join(separator)
}

export  function ValidateString (str, validationType) { 

  if(!str) 
    return VALIDATION_ERROR.EMPTY

  switch(validationType) { 
      case VALIDATION_TYPE.PHONE_NUMBER : 
        // eslint-disable-next-line
        if (!str.match(/^[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4}$/im)) { 
          return VALIDATION_ERROR.PHONE_NUMBER_INVALID
        }
        break
      case VALIDATION_TYPE.EMAIL : 
        if(!str.match(/^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/)) { 
          return VALIDATION_ERROR.EMAIL_INVALID
        }
        break
      case VALIDATION_TYPE.DATE_VALID : 
        let miliseconds = parseInt(str)
        let dateObj = null

        if(miliseconds > 0) { 
          dateObj = new Date(miliseconds)
        } else { 
          dateObj = new Date(str)
        }
        
        if(!dateObj) { 
          return VALIDATION_ERROR.EMPTY
        }
        
        if(dateObj && isNaN(dateObj.getTime())) {
          return VALIDATION_ERROR.DATE_INVALID
        }

        break
      case VALIDATION_TYPE.CANADA_PROVINCE_CODE :
        if(str === "unknown")
          return VALIDATION_ERROR.EMPTY
        
        if (Object.keys(CanadaProvinceList).findIndex(p => p === str) === -1)
          return VALIDATION_ERROR.CANADA_PROVINCE_CODE_INVALID
        break
      case VALIDATION_TYPE.CANADA_POSTAL_CODE : 
        /*
          The postal code is a six-character code defined and maintained by Canada Post Corporation 
          (CPC) for the purpose of sorting and delivering mail. The characters are arranged in the 
          form ‘ANA NAN’, where ‘A’ represents an alphabetic character and ‘N’ represents a numeric 
          character (e.g., K1A 0T6). The postal code uses 18 alphabetic characters and 10 numeric 
          characters. Postal codes do not include the letters D, F, I, O, Q or U, and the first 
          position also does not make use of the letters W or Z.
         */ 
        if(!str.match(/^[ABCEGHJ-NPRSTVXY][0-9][ABCEGHJ-NPRSTV-Z] ?[0-9][ABCEGHJ-NPRSTV-Z][0-9]$/i)) { 
          return VALIDATION_ERROR.CANADA_POSTAL_CODE_INVALID
        }
        break
      default : 
        return VALIDATION_ERROR.NO_ERROR
  }

  return VALIDATION_ERROR.NO_ERROR
}

export function IsDateInFuture(miliseconds) { 
  return (Date.now() < miliseconds)
}

export function IsTodayWithinRange(startDate, endDate) {
  return (Date.now() >= startDate && endDate > Date.now())
}

export function IsDateYearCurrentYear(date) {
  if(!date) { 
    return false
  }

  const dateObj = new Date(parseInt(date))
  const currentDateObj = new Date(Date.now())

  const option = {
    year: "numeric",
  }

  const dateYear =  dateObj.toLocaleDateString("en-US",option)
  const currentYear =  currentDateObj.toLocaleDateString("en-US",option)
  if(dateYear === currentYear) {
    return true
  }

  return false
}

export function isUserBusinessAdmin(user) { 
  if(user.authorities && Array.isArray(user.authorities)) {
      for(let i = 0; i < user.authorities.length; i++) {
          let auth = user.authorities[i]
          if (auth.authority === AUTHORITY_BUSINESS_LICENCE_ADMIN)  {
              return true
          }
      }
  }

  return false
}

export function storageAvailable(type) {
  var storage;
  try {
      storage = window[type];
      var x = '__storage_test__';
      storage.setItem(x, x);
      storage.removeItem(x);
      return true;
  }
  catch(e) {
      return e instanceof DOMException && (
          // everything except Firefox
          e.code === 22 ||
          // Firefox
          e.code === 1014 ||
          // test name field too, because code might not be present
          // everything except Firefox
          e.name === 'QuotaExceededError' ||
          // Firefox
          e.name === 'NS_ERROR_DOM_QUOTA_REACHED') &&
          // acknowledge QuotaExceededError only if there's something already stored
          (storage && storage.length !== 0);
  }
}

export function licenceSubTypeString(licencingSubType, considerRenewal = false) { 

  switch(licencingSubType) { 
      case LICENCE_SUB_TYPE_ALL : 
          return "All"
      case LICENCE_SUB_TYPE_COLLECTION_AGENCY_APPLICATION :
          return "Collection Agency"
      case LICENCE_SUB_TYPE_COLLECTION_AGENCY_RENEWAL : 
          if(!considerRenewal) return "Collection Agency"
          return "Collection Agency Renewal"
      case LICENCE_SUB_TYPE_COLLECTION_COLLECTOR_APPLICATION :
          return "Collector" 
      case LICENCE_SUB_TYPE_COLLECTION_COLLECTOR_RENEWAL : 
          if(!considerRenewal) return "Collector"
          return "Collector Renewal"
      case LICENCE_SUB_TYPE_MORTGAGE_BROKERAGE_NEW_APPLICATION :
        return "Mortgage Brokerage"
      case LICENCE_SUB_TYPE_MORTGAGE_BROKERAGE_CHANGE_APPLICATION : 
          return "Mortgage Brokerage - Change Application"
      case LICENCE_SUB_TYPE_PRINCIPAL_BROKER_NEW_APPLICATION :
          return "Mortgage Broker (PB)"
      case LICENCE_SUB_TYPE_MORTGAGE_BROKER_NEW_APPLICATION :
          return "Mortgage Broker"
      case LICENCE_SUB_TYPE_ASSOCIATE_MORTGAGE_BROKER_NEW_APPLICATION :
          return "Mortgage Broker (Associate)"
      case LICENCE_SUB_TYPE_DEBT_MANAGEMENT_APPLICATION : 
          return "Debt Management Agency"
      case LICENCE_SUB_TYPE_DEBT_MANAGEMENT_RENEWAL :
          if(!considerRenewal) return "Debt Management Agency"
          return "Debt Management Agency Renewal"
      case LICENCE_SUB_TYPE_DEBT_MANAGEMENT_INDIVIDUAL_APPLICATION : 
          return "Debt Management Agent"
      case LICENCE_SUB_TYPE_DEBT_MANAGEMENT_INDIVIDUAL_RENEWAL : 
          if(!considerRenewal) return "Debt Management Agent"
          return "Debt Management Agent Renewal"
      case LICENCE_SUB_TYPE_MORTGAGE_LENDER_NEW_APPLICATION : 
          return "Mortgage Lender"
      case LICENCE_SUB_TYPE_MORTGAGE_LENDER_CHANGE_APPLICATION : 
          return "Mortgage Lender - Change Application"
      case LICENCE_SUB_TYPE_MORTGAGE_ADMINISTRATOR_NEW_APPLICATION : 
      return "Mortgage Administrator"
      case LICENCE_SUB_TYPE_MORTGAGE_ADMINISTRATOR_CHANGE_APPLICATION : 
          return "Mortgage Administrator - Change Application"
      case LICENCE_SUB_TYPE_MORTGAGE_BROKERAGE_RENEWAL_APPLICATION:
          if(!considerRenewal) return "Mortgage Brokerage";
          return "Mortgage Brokerage Renewal"
      case LICENCE_SUB_TYPE_MORTGAGE_BROKER_RENEWAL_APPLICATION:
          if(!considerRenewal) return "Mortgage Broker";
          return "Mortgage Broker Renewal"
      case LICENCE_SUB_TYPE_PRINCIPAL_BROKER_RENEWAL_APPLICATION:
          if(!considerRenewal) return "Mortgage Broker (PB)";
          return "Mortgage Broker (PB) Renewal"
      case LICENCE_SUB_TYPE_ASSOCIATE_MORTGAGE_BROKER_RENEWAL_APPLICATION :
          if(!considerRenewal) return "Mortgage Broker (Associate)";
          return "Mortgage Broker (Associate) Renewal"
      case LICENCE_SUB_TYPE_MORTGAGE_LENDER_RENEWAL_APPLICATION :
          if(!considerRenewal) return "Mortgage Lender";
          return "Mortgage Lender Renewal"
      case LICENCE_SUB_TYPE_MORTGAGE_ADMINISTRATOR_RENEWAL_APPLICATION : 
          if(!considerRenewal)  return "Mortgage Administrator";
          return "Mortgage Administrator Renewal"
      case LICENCE_SUB_TYPE_INDIVIDUAL_PRINCIPAL_BROKER_APPLICATION: 
          return "Principal Broker Application"
      case LICENCE_SUB_TYPE_INDIVIDUAL_COMPLIANCE_OFFICER_APPLICATION:
          return "Compliance Officer Application"
      case LICENCE_SUB_TYPE_INDIVIDUAL_PRINCIPAL_BROKER_RETENTION_APPLICATION: 
          return "Principal Broker Change Request"
      case LICENCE_SUB_TYPE_INDIVIDUAL_COMPLIANCE_OFFICER_RETENTION_APPLICATION:
          return "Compliance Officer Change Request"
      default : 
          return licencingSubType
  }
}

/*
 * The logic of deciding the legal name and operating name is pulled in 
 * this util function so that it remains same everywhere.
 */
export function decideLegalAndOperatingNames(companyRjscDetails) {
  let legalName = null
  let operatingName = null

  if(companyRjscDetails) {
    const {businessEntity, businessData} = companyRjscDetails

    if(businessEntity?.businessName && !businessData?.businessOwner) {
      legalName = businessEntity?.businessName
    } else if(businessEntity?.businessName && businessData?.businessOwner) {
      legalName = businessData?.businessOwner
      operatingName = businessEntity?.businessName
    } else if(!businessEntity?.businessName && businessData?.businessOwner) {
      legalName = businessData?.businessOwner
    }
  }

  return {
    legalName,
    operatingName
  }
}

/**
 * 
 * @param {companyRjscDetails} : rjsc data 
 * 
 * If the company has parent regId, return that otherwise return its own regId
 */
export function decideRegistryId(companyRjscDetails) {
  if(companyRjscDetails?.businessData?.relatedTo) {
    return companyRjscDetails.businessData.relatedTo
  }

  return companyRjscDetails?.businessEntity?.registryNumber
}

/*
 This function will break the string into a JSX if its a string
 and while converting, it can format it for new line for now.
 we can integrate other formatting options in future, like bold, etc.
*/
export const strJSX = (str) => {
  if(typeof str !== "string") return str
  return str.split("\n").map(v => <>{v}<br /></>)
}

export const isSuperUser = (email) => (SUPER_USERS.findIndex((e) => e.toLowerCase() === email.toLowerCase()) !== -1)

export const documentTypeString = documentType => {
  switch(documentType) {
    case DOCUMENT_TYPE_INSURANCE_CONTINURATION : 
      return "Insurance Continuation Certificate"
    case DOCUMENT_TYPE_INSURANCE_PROOF : 
      return "Proof of Insurance"
    default : 
      return documentType
  }
}

export const isBranchApplication = (application) => {
  if(application 
      && isAgencyTypeApplication(application)
      && isCollectionTypeApplication(applicationTypeFromLicenceSubType(application.licencingSubType)) 
      && !!application.businessApplicationId) {
    return true;
  }

  return false;
}
